<template>
  <div class="virtual-booth-holder" ref="virtualBoothHolder">
    <div class="unity_progress_bar" v-if="unity_progress != '100%'">
      <div class="unity_progress" :style="progress_bar_style"></div>
    </div>
    <!--    <div divclass="text-xm text-orange-400 pb-10">-->
    <!--      page_state:{{ this.$store.state.page_state }}<br />-->
    <!--      app_state:{{ this.$store.state.app_state }}<br />-->
    <!--      app_type:{{ this.$store.state.app_type }}<br />-->
    <!--    </div>-->
    <transition name="fade" mode="out-in">
      <template>
        <div
          id="video-intro-cover"
          key="1"
          v-if="
            site_config.use_intro_video &&
            !show_booth_form &&
            !show_mobile_warning &&
            page_state < 1
          "
          class="video-container container mx-auto"
        >
          <a
            href="#"
            @click="on_video_cover_clicked($event)"
            class="block container video-intro-link z-30"
            v-if="
              site_config.use_intro_image &&
              page_state == 0 &&
              video_clicked == false
            "
            ><img class="block" src="../assets/intro-cover.jpg"
          /></a>
          <video
            class="z-10"
            v-if="page_state == 0"
            playsinline
            @ended="on_video_end"
            ref="intro_video"
          >
            <source src="../../static/video/intro.webm" type="video/webm" />
            <source src="../../static/video/intro.mp4" type="video/mp4" />
          </video>
          <!--          <a-->
          <!--            href="@"-->
          <!--            @click="skip_video($event)"-->
          <!--            class="inline-block p-1 px-10 bg-yellow-400 text-orange-600 text-sm rounded ml-auto mr-0 my-2 shadow-md uppercase"-->
          <!--            >skip</a-->
          <!--          >-->
        </div>
        <div
          key="2"
          class="container text-red text-center mx-auto"
          v-else-if="show_mobile_warning"
        >
          <div class="w-full max-w-lg mx-auto">
            <div
              class="bg-white sm:shadow-md sm:rounded px-4 sm:px-8 pt-6 pb-2 sm:pb-8 mb-2 sm:mb-4"
              ref="entrance_form"
            >
              <div class="font-bold text-md pb-4">
                The high definition version site may not work on older mobile
                devices.
              </div>
              <div class="block text-gray-600 text-sm">
                Please select:
              </div>
              <div class="flex flex-col flex-grow text-md">
                <button
                  class="uppercase bg-default-btn-color hover:bg-default-btn-color-hover text-white font-bold py-3 sm:py-2 px-1 rounded focus:outline-none focus:shadow-outline w-full my-2"
                  type="button"
                  @click="choose_mobile"
                >
                  Standard Definition (most phones)
                </button>
                <button
                  class="uppercase bg-default-btn-color hover:bg-default-btn-color-hover text-white font-bold py-3 sm:py-2 px-1 rounded focus:outline-none focus:shadow-outline w-full my-2"
                  type="button"
                  @click="choose_desktop"
                >
                  High Definition (new phones)
                </button>
              </div>
            </div>
          </div>
        </div>
        <BoothForm key="3" v-else-if="show_booth_form" />
      </template>
    </transition>
    <UnityContainer />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BoothEntry from "../components/BoothEntry";
import UnityContainer from "../components/UnityContainer";
import { page } from "vue-analytics";
import BoothForm from "../components/BoothForm";
export default {
  name: "LandingPage",
  components: {
    BoothForm,
    BoothEntry,
    UnityContainer
  },
  data() {
    return {
      video_clicked: false
    };
  },
  computed: {
    ...mapState(["app_type", "page_state", "browser_is_mobile", "site_config"]),
    ...mapGetters(["eventTag"]),
    show_booth_form() {
      return (
        this.$store.state.page_state == 1 ||
        (this.$store.state.page_state == 2 && this.$store.state.app_state < 0)
      );
    },
    show_mobile_warning() {
      return this.$store.state.page_state == 21;
    },
    unity_progress() {
      return this.$store.state.unity_progress * 100 + "%";
    },
    progress_bar_style() {
      return "width:" + this.unity_progress;
    }
  },
  methods: {
    on_video_end() {
      //if it's mobile, show a warning
      if (this.browser_is_mobile) {
        this.$store.dispatch("set_page_state", 21);
      } else {
        this.$store.dispatch("set_page_state", 1);
        this.$bus.$emit("on-request-unity-load");
      }
    },
    on_video_cover_clicked(e) {
      e.preventDefault();
      this.video_clicked = true;
      this.$refs.intro_video.play();
      setTimeout(
        (() => {
          this.$bus.$emit("on-request-audio", "intro");
        }).bind(this),
        900
      );
    },
    skip_video(e) {
      e.preventDefault();
      this.$refs.intro_video.pause();
      this.on_video_end();
    },
    choose_mobile() {
      this.$store.dispatch("set_simple_val", {
        name: "app_type",
        val: "mobile"
      });
      this.$store.dispatch("set_page_state", 1);
    },
    choose_desktop() {
      this.$store.dispatch("set_simple_val", {
        name: "app_type",
        val: "desktop"
      });
      this.$store.dispatch("set_page_state", 1);
      this.$bus.$emit("on-request-unity-load");
    },
    on_request_booth_resize(el) {
      console.log(
        "resize to booth",
        this.$refs.virtualBoothHolder,
        this.$refs.virtualBoothHolder.clientHeight
      );
      el.style.height = "10vh";

      el.style.height = this.$refs.virtualBoothHolder.clientHeight + "px";
    }
  },
  mounted() {
    this.$bus.$on("on-request-booth-resize", this.on_request_booth_resize);
    //this.$store.dispatch("set_page_state", 1);
    //this.$store.dispatch("set_app_state", 0);

    this.$ga.page("/" + this.eventTag + "/");

    if (this.site_config.use_intro_video && !this.site_config.use_intro_image) {
      this.video_clicked = true;
      this.$refs.intro_video.play();
    } else if (!this.site_config.use_intro_video) {
      this.on_video_end();
    }
    //setTimeout((function(){
    //this.$refs.intro_video.currentTime = 9;
    // window.getStr('video_popup', '1')
    //}).bind(this), 5000);
  },
  watch: {
    page_state(val) {
      console.log("val changed to " + val, this.app_type);
      if (val == 2 && this.app_type == "mobile") {
        console.log("sending app state 0");
        this.$store.dispatch("set_app_state", 0);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.unity_progress_bar {
  height: 4px;
  background: #ddd;
  overflow: hidden;
  position: absolute;
  width: 100%;
  top: 0;
}
.unity_progress {
  background: #fb0000;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.video-container {
  width: 100%;
}

.video-container video,
.video-container img {
  width: 100%;
  max-height: 70vh;
}
.video-container img {
  object-fit: contain;
}
.video-container .video-intro-link {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue